import type { IExportAccessRepository } from '../repositories/IExportAccessRepository.js';

interface Deps { exportAccessRepository: IExportAccessRepository; }
export interface DeleteExportGrantInput { orgId: string; exportKey: string; }
export function createDeleteExportGrantUseCase({ exportAccessRepository }: Deps) {
  return async function deleteExportGrant(input: DeleteExportGrantInput): Promise<void> {
    return exportAccessRepository.deleteGrant(input);
  };
}
